import React from "react";
import ExplorationFlutter from "src/components/explorationFlutter/explorationFlutter";
import ExplorationFlutterLayout from "src/components/explorationFlutter/explorationFlutter-layout";
const ExplorationFlutterPage: React.FC = () => {
  return (
    <ExplorationFlutterLayout
      children={<ExplorationFlutter />}
    ></ExplorationFlutterLayout>
  );
};
export default ExplorationFlutterPage;
